module.exports = __webpack_public_path__ + "s14.no1.a063a6a4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/s14.no1.jpg
// module id = xrBH
// module chunks = 0